import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, CartService, GungModalService, SaveCartModalConfigService } from 'gung-standard';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-cart-list-buttons',
    templateUrl: './colmec-cart-list-buttons.component.html',
    styleUrls: ['./colmec-cart-list-buttons.component.scss'],
    standalone: false
})
export class ColmecCartListButtonsComponent implements OnInit {
  public isSales = false;
  constructor(
    protected gungModalService: GungModalService,
    protected translationService: TranslateService,
    protected saveCartModalConfigService: SaveCartModalConfigService,
    protected cartService: CartService,
    protected authService: AuthService
  ) {}

  ngOnInit(): void {
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => (this.isSales = roles.filter(role => role.toUpperCase() === 'SALES').length > 0));
  }

  emptyCart(): void {
    this.gungModalService
      .openConfirmYesNoModal(undefined, this.translationService.instant('CLEAR_CART_CONFIRM'), { size: 'sm' })
      .then(
        result => {
          if (result) {
            this.cartService.clearCart();
          }
        },
        reason => {}
      );
  }

  saveCart(): void {
    this.saveCartModalConfigService.openSaveCartModal();
  }

  createQuotation(): void {
    this.saveCartModalConfigService.openCreateQuotationModal();
  }
}
